import TopBar from "@/components/app/TopBar";
import Sidebar from "@/components/app/Sidebar";
import RightRail from "@/components/app/RightRail";

export default function AppLayout({ children, hideRightRail = false }) {
  return (
    <div className="bg-cream min-h-screen text-ink">
      <TopBar />
      <div className="max-w-[1600px] mx-auto flex">
        <Sidebar />
        <main className="flex-1 min-w-0 px-4 md:px-6 lg:px-8 py-5">
          <div className="max-w-[920px] mx-auto">
            {children}
          </div>
        </main>
        {!hideRightRail && <RightRail />}
      </div>
    </div>
  );
}

export function PageHeader({ kicker, title, subtitle, actions }) {
  return (
    <header className="mb-6">
      {kicker && <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-coral">{kicker}</p>}
      <div className="flex items-end justify-between gap-4 mt-2">
        <div className="min-w-0">
          <h1 className="font-serif text-4xl md:text-5xl tracking-tighter leading-none">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-ink-mid">{subtitle}</p>}
        </div>
        {actions && <div className="shrink-0 flex items-center gap-2">{actions}</div>}
      </div>
    </header>
  );
}

export function ComingSoonNote({ feature, eta }) {
  return (
    <div className="mt-6 border hairline bg-cream-card rounded-2xl p-5 text-sm text-ink-mid" data-testid="coming-soon-note">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-coral mb-1">Próxima fase</p>
      Esta sección ya está cableada al backend (puedes ver y usar lo básico). Versión completa con <strong>{feature}</strong> llegando {eta}.
    </div>
  );
}
